import aire from "../../Assets/aire.png";
import Incentiva from "../../Assets/incentiva-logo.png";
import AIStuff from "../../Assets/ai-stuff-image.png";
import PrimaryRecord from "../../Assets/primary-record-icon.PNG";
import YoutubeClone from "../../Assets/youtube-clone-home.png";
import InstagramClone from "../../Assets/instagram-logo.png";
import CloudUI from "../../Assets/cloud-logo.png";
import Kurricula from "../../Assets/kurriculalogo.png";
import InHax from "../../Assets/inhax-logo.png";

export const websites = [
  {
    image: aire,
    href: "https://useaire.tech/",
    linkPreview: "useaire.tech",
    title: "aire",
    description:
      "Tailors your resume to a job posting using AI. Additionally, AI is used to parse information from your resume.",
    color: "group-hover:text-gray-400",
    bg: "bg-gradient-to-tr from-white to-black shadow-gray-400/20",
  },
  {
    image: Incentiva,
    href: "https://incentiva.netlify.app/",
    linkPreview: "incentiva.app",
    title: "Incentiva",
    description:
      "Task manager website with AI that assesses which tasks make you the happiest.",
    color: "group-hover:text-violet-500",
    bg: "bg-gradient-to-tr from-violet-300 to-violet-500 shadow-violet-500/20",
  },
  /*
    {
        image: AIStuff,
        href: "https://aistuff.netlify.app/",
        title: "AI Stuff",
        color: "text-violet-500",
        bg: "bg-gradient-to-tr from-green-300 to-green-500 hover:shadow-green-500/20"
    },
    */
  {
    image: PrimaryRecord,
    href: "https://primary-record.netlify.app/",
    linkPreview: "primary-record.netlify.app",
    title: "Primary Record",
    description:
      "Categorizes the text from a photo of a prescription label that the user uploads.",
    color: "group-hover:text-blue-500",
    bg: "bg-gradient-to-tr from-blue-300 to-blue-500 shadow-blue-500/20",
  },
  /*
    {
        image: YoutubeClone,
        href: "https://youtube-clone-mui.netlify.app/",
        title: "Youtube Clone",
        color: "text-violet-500",
        bg: "bg-gradient-to-tr from-red-300 to-red-500 hover:shadow-red-500/20"
    },
    */
  //   {
  //     image: InstagramClone,
  //     href: "https://instagram-clone-chakra.netlify.app/",
  //     linkPreview: "instagram-clone-chakra.netlify.app",
  //     title: "Instagram Clone",
  //     description: "Visual clone of the Instagram website, made with Chakra UI.",
  //     color: "group-hover:text-orange-500",
  //     bg: "bg-gradient-to-tr from-orange-500 to-violet-500 shadow-orange-500/20",
  //   },
  {
    image: CloudUI,
    href: "https://cloudui.netlify.app/",
    linkPreview: "cloudui.netlify.app",
    title: "Cloud UI",
    description:
      "Components made for React JS, created with Tailwind CSS and Framer Motion.",
    color: "group-hover:text-sky-500",
    bg: "bg-gradient-to-tr from-sky-300 to-sky-500 shadow-sky-500/40",
  },
  {
    image: Kurricula,
    href: "https://kurricula.netlify.app/",
    linkPreview: "kurricula.netlify.app",
    title: "Kurricula",
    description:
      "Website that allows students to see and leave reviews on courses they've taken.",
    color: "group-hover:text-emerald-500",
    bg: "bg-gradient-to-tr from-emerald-500 to-indigo-500 shadow-emerald-500/20",
  },
  {
    image: InHax,
    href: "https://inhax.vercel.app/",
    linkPreview: "inhax.dev",
    title: "Indiana Hax",
    description:
      "Information page on Indiana Hax, the hackathon organization I created.",
    color: "group-hover:text-yellow-500",
    bg: "bg-gradient-to-tr from-yellow-200 to-rose-300 shadow-rose-300/20",
  },
];
